import { AngularServices } from '../../../../modules/core';
import { VideoProviderEvents } from '../../../../providers/video/';
import { ErrorTrack } from '../error.track';
var ErrorSubtype;
(function (ErrorSubtype) {
    ErrorSubtype["video"] = "video";
    ErrorSubtype["audio"] = "audio";
    ErrorSubtype["media"] = "media";
})(ErrorSubtype || (ErrorSubtype = {}));
export default class PublisherMultipleTracks extends ErrorTrack {
    constructor() {
        super(...arguments);
        this.errorType = 'Publisher Multiple Tracks';
        this.previousErrorsMap = new WeakMap();
    }
    async start() {
        const videoProviderFactory = this.$injector.get(AngularServices.VideoProviderFactory);
        await videoProviderFactory.waitForActiveProvider();
        videoProviderFactory.activeProvider.on(VideoProviderEvents.LocalStream, (stream) => {
            this.process(stream);
            let timer;
            const addTrack = stream.addTrack.bind(stream);
            stream.addTrack = (track) => {
                addTrack(track);
                clearTimeout(timer);
                timer = setTimeout(() => this.process(stream), 100);
            };
        });
    }
    process(stream) {
        const error = this.hasError(stream);
        if (error) {
            this.trackSegment({
                errorType: this.errorType,
                errorSubtype: error,
            });
        }
    }
    hasError(stream) {
        const previousErrors = this.getPreviousErrors(stream);
        const audioTracks = stream.getAudioTracks();
        const videoTracks = stream.getVideoTracks();
        if (audioTracks.length > 1 &&
            videoTracks.length > 1 &&
            !previousErrors[ErrorSubtype.media]) {
            previousErrors[ErrorSubtype.media] = true;
            return ErrorSubtype.media;
        }
        if (audioTracks.length > 1 && !previousErrors[ErrorSubtype.audio]) {
            previousErrors[ErrorSubtype.audio] = true;
            return ErrorSubtype.audio;
        }
        if (videoTracks.length > 1 && !previousErrors[ErrorSubtype.video]) {
            previousErrors[ErrorSubtype.video] = true;
            return ErrorSubtype.video;
        }
        return;
    }
    getPreviousErrors(stream) {
        if (!this.previousErrorsMap.has(stream)) {
            this.previousErrorsMap.set(stream, {});
        }
        return this.previousErrorsMap.get(stream);
    }
}
